import { Coffee, Download } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { API } from "@/lib/api";

const steps = [
  {
    tag: "Fase 01",
    title: "Pre-bootcamp",
    text: "Onboarding, assessment della tua idea e materiali preparatori per arrivare pronto.",
  },
  {
    tag: "Fase 02",
    title: "Due week-end residenziali",
    text: "Full immersion in masseria: 13–14 e 27–28 Novembre 2026. Si lavora, si fa convivialità e networking e si dorme nello stesso luogo — i rapporti tra colleghi diventano la prima risorsa d'impresa.",
  },
  {
    tag: "Fase 03",
    title: "Follow-up 8 settimane",
    text: "Accompagnamento post-evento per trasformare il modello in prime azioni reali.",
  },
];

export const Formula = () => (
  <section id="formula" className="relative bg-[#F4F6FB] py-24 sm:py-32" data-testid="formula-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Overline>La formula</Overline>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-5 max-w-2xl font-display text-4xl font-black uppercase leading-[0.98] tracking-tight text-[#16256B] sm:text-5xl lg:text-6xl">
          Come funziona
        </h2>
      </Reveal>

      <div className="relative mt-16">
        <div className="absolute left-0 right-0 top-8 hidden h-px bg-gradient-to-r from-[#16256B] via-[#C9A227] to-[#16256B] md:block" />
        <div className="grid gap-10 md:grid-cols-3">
          {steps.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.15} data-testid={`formula-step-${i}`}>
              <div className="relative">
                <div className="flex h-16 w-16 items-center justify-center rounded-full border-2 border-[#C9A227] bg-white font-display text-2xl font-black text-[#16256B]">
                  {i + 1}
                </div>
                <p className="mt-6 font-body text-xs uppercase tracking-overline text-[#2D46A0]">
                  {s.tag}
                </p>
                <h3 className="mt-2 font-display text-2xl font-extrabold text-[#16256B]">
                  {s.title}
                </h3>
                <p className="mt-3 max-w-xs font-body text-sm leading-relaxed text-[#4A5268]">
                  {s.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal delay={0.2}>
        <div className="mt-14 overflow-hidden rounded-3xl bg-[#0E1A4A] p-8 sm:p-12">
          <div className="grid gap-6 lg:grid-cols-[auto_1fr] lg:items-center lg:gap-12">
            <div className="flex items-center gap-4">
              <span className="font-display text-6xl font-black leading-none text-[#C9A227] sm:text-7xl">4</span>
              <div className="font-display text-sm font-bold uppercase leading-tight tracking-wide text-white/80 sm:text-base">
                giorni<br />residenziali
              </div>
            </div>
            <div>
              <p className="font-body text-xs uppercase tracking-overline text-[#C9A227]">Full immersion in masseria</p>
              <p className="mt-3 font-display text-2xl font-black leading-tight text-white sm:text-3xl">
                Coltiva le relazioni, investi su te stesso e trasforma il tuo futuro.
              </p>
              <p className="mt-4 max-w-2xl font-body text-sm leading-relaxed text-white/70 sm:text-base">
                Due week-end interi &mdash; 13&ndash;14 e 27&ndash;28 Novembre &mdash; dove si vive l&rsquo;esperienza al 100%: lavoro, colazione, light lunch e momenti conviviali nella stessa masseria. È qui che nascono le relazioni che resteranno dopo il corso.
              </p>
            </div>
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.3}>
        <div className="mt-6 flex flex-wrap items-center gap-3">
          <div className="inline-flex items-center gap-3 rounded-full border border-[#E4E8F2] bg-white px-5 py-3">
            <Coffee className="h-5 w-5 text-[#C9A227]" />
            <span className="font-body text-sm text-[#4A5268]">
              Colazione di benvenuto e light lunch inclusi
            </span>
          </div>
          <a
            href={`${API}/programma.pdf`}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-2.5 rounded-full bg-[#16256B] px-5 py-3 font-body text-sm font-semibold text-white transition-colors duration-200 hover:bg-[#0E1A4A]"
            data-testid="formula-download-program"
          >
            <Download className="h-4 w-4 transition-transform duration-300 group-hover:translate-y-0.5" />
            Scarica il programma completo (PDF)
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
